// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const venipede: PokeData = {
  "id": 543,
  "name": "venipede",
  "height": 4,
  "weight": 53,
  "base_experience": 52,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "poison-sting",
    "toxic",
    "agility",
    "screech",
    "defense-curl",
    "protect",
    "rollout",
    "pursuit",
    "poison-tail",
    "rock-climb",
    "bug-bite",
    "venoshock",
    "steamroller",
    "venom-drench"
  ],
  "moves": [
    "protect",
    "pursuit",
    "bug-bite",
    "venom-drench",
    "poison-jab",
    "signal-spam",
    "pounce",
    "toxic-spikes",
    "lunge",
    "sludge-bomb",
    "purify",
    "heal-order",
    "poison-powder"
  ],
  "evolution_chain": {
    "id": 277,
    "item": null,
    "species": [
      {
        "name": "venipede",
        "order": 544,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whirlipede",
        "order": 545,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 543,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "scolipede",
        "order": 546,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 544,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39.5,
    "speed": 57,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
